<template>
  <div class="flex w-full justify-center">
    <DonationStandard
      v-model:sum="localSum"
      :sums="activeSums"
      :currency="currency"
      :min-sum="minSum"
      :image="image"
      :v$="v$"
      :show-toggle="true"
      :toggle-tabs="tabs"
      :selected-toggle-tab="selectedTab"
      @on-next="handleNext"
      @toggle-change="handleToggleChange"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, watch, computed, nextTick } from 'vue'
import { DonationStandard } from 'act-components'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
  sum: number | undefined
  currency: 'sek' | 'eur' | 'usd'
  minSum: number
  image: string
  v$: any
  sums: number[]
  monthlySums?: number[]
}>()

const { t } = useI18n()

const tabs = computed(() => [t('donation.single'), t('donation.monthly')])

const emit = defineEmits(['update:sum', 'on-next'])

const selectedTab = ref(0) // 0 = single, 1 = monthly
const localSum = ref<number>(props.sum ?? 0)

const activeSums = computed(() =>
  selectedTab.value === 0 ? props.sums : props.monthlySums || props.sums,
)

watch(
  () => props.sum,
  val => (localSum.value = val ?? 0),
)
watch(localSum, val => emit('update:sum', val))

const handleToggleChange = (newTab: number) => {
  selectedTab.value = newTab
  // Ensure the sum is updated before any potential navigation
  emit('update:sum', localSum.value)
}

const handleNext = () => {
  // Ensure the sum is updated before navigation
  emit('update:sum', localSum.value)
  // Use nextTick to ensure the parent component has received the sum update
  nextTick(() => {
    emit('on-next', selectedTab.value === 0 ? 'single' : 'monthly')
  })
}
</script>
